import { render, staticRenderFns } from "./AwarenessBanner.vue?vue&type=template&id=45e1e07c"
import script from "./AwarenessBanner.vue?vue&type=script&lang=js"
export * from "./AwarenessBanner.vue?vue&type=script&lang=js"
import style0 from "./AwarenessBanner.vue?vue&type=style&index=0&id=45e1e07c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports